import { Typography } from "@mui/material";
import React from "react";
import transformDateToDe from "../../../../functions/transformDateToDe";
import { DayliPlanContext } from "../context/dayliPlanContext";
import IDayliPlan from "../interface/iDayliPlan";

const FoundResultsText = (): React.JSX.Element => {
  const {
    dayliPlan,
  }: {
    dayliPlan: IDayliPlan;
  } = React.useContext(DayliPlanContext);

  return (
    <Typography variant="body1" component="p">
      {`Vom ${transformDateToDe(dayliPlan.fromDate)} bis ${transformDateToDe(
        dayliPlan.tillDate
      )} wurden ${dayliPlan.appointments.length} Termine gefunden`}
    </Typography>
  );
};

export default FoundResultsText;
